import { render, staticRenderFns } from "./PreviewCourse.vue?vue&type=template&id=a71e78ac&scoped=true&"
import script from "./PreviewCourse.vue?vue&type=script&lang=js&"
export * from "./PreviewCourse.vue?vue&type=script&lang=js&"
import style0 from "./PreviewCourse.vue?vue&type=style&index=0&id=a71e78ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71e78ac",
  null
  
)

export default component.exports